import { NOT_KNOWN } from 'customer-data-filters/converters/contactSearch/FilterContactSearchOperatorTypes';
import { QUEUE_IDS } from 'customer-data-objects/task/TaskPropertyNames';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback, useMemo } from 'react';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { OPERATORS_TO_NOT_SHOW_CHECKS_IN_SELECT } from '../../constants/viewFilters';
import { useDispatch } from '../../context/Redux';
import { useTempFilters } from '../../hooks/useTempFilters';
import { updateTempViewCrmSearchQuery } from '../../redux/actions/tempViewState';
import { getQueueMembershipIdsFilter } from '../../utils/crmSearchFilters';
import { getPropertyFilter } from '../../utils/getPropertyFilterValue';
import { QueueSelect } from './QueueSelect';
import QuickFilterContainer from './QuickFilterContainer';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const QUEUE_OPERATORS_TO_NOT_SHOW_CHECKS_IN_SELECT = [...OPERATORS_TO_NOT_SHOW_CHECKS_IN_SELECT, NOT_KNOWN];
export const getQueueValueFromFilters = crmSearchFilters => {
  const filterObject = getPropertyFilter(crmSearchFilters, QUEUE_IDS);
  if (!filterObject || QUEUE_OPERATORS_TO_NOT_SHOW_CHECKS_IN_SELECT.includes(filterObject.operator)) {
    return [];
  } else {
    const filterValues = filterObject.value ? [filterObject.value] : filterObject.values;
    // need to make sure the values are always strings so that the filter
    // editor and quick filter stay in sync
    return filterValues.map(String);
  }
};
const QueueFilter = ({
  viewId
}) => {
  const dispatch = useDispatch();
  const crmSearchFilters = useTempFilters(viewId);
  const value = useMemo(() => getQueueValueFromFilters(crmSearchFilters), [crmSearchFilters]);
  const handleChange = useCallback(event => {
    const eventValue = event.target.value;
    const filtersWithoutQueue = crmSearchFilters.filter(filter => filter.property !== QUEUE_IDS);
    let newFilters;
    if (!Array.isArray(eventValue) || eventValue.length === 0) {
      newFilters = filtersWithoutQueue;
    } else {
      newFilters = [...filtersWithoutQueue, getQueueMembershipIdsFilter(eventValue)];
    }
    dispatch(updateTempViewCrmSearchQuery({
      viewId,
      crmSearchFilters: newFilters
    }));
  }, [crmSearchFilters, viewId, dispatch]);
  const shouldHighlightFilter = useMemo(() => {
    const filterObject = getPropertyFilter(crmSearchFilters, QUEUE_IDS);
    const areQueuesSelected = Array.isArray(value) && value.length > 0;
    // check if the filter is using an operator that shouldn't show any checks
    const isFilterApplied = Boolean(filterObject) && QUEUE_OPERATORS_TO_NOT_SHOW_CHECKS_IN_SELECT.includes(filterObject.operator);
    return isFilterApplied || areQueuesSelected;
  }, [crmSearchFilters, value]);
  const onClear = useCallback(() => handleChange(syntheticEvent([])), [handleChange]);
  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "tasks-table.filters.queue.tooltip"
    }),
    children: /*#__PURE__*/_jsx(QuickFilterContainer, {
      filterName: "queue",
      shouldHighlight: shouldHighlightFilter,
      shouldShowClearButton: shouldHighlightFilter,
      onClear: onClear,
      children: /*#__PURE__*/_jsx(QueueSelect, {
        "data-selenium-test": "queue-quick-filter",
        "data-test-id": "queue-quick-filter",
        onChange: handleChange,
        value: value
      })
    })
  });
};
export default QueueFilter;